import store from './store'
import roles from './helpers/userRoles'

const checkAuth = () => {
  return true
}

const checkIsAdmin = () => {
  return store.getters.role === roles.admin
}

const checkIsAddAgent = () => {
  return store.getters.role === roles.adAgent
}

const requireAuth = (to, from, next) => {
  if (!checkAuth() || checkIsAdmin()) {
    const path = checkIsAdmin() ? '/admin' : '/login'
    next({
      path: path
    })
  } else if (checkIsAddAgent()) {
    next({
      path: '/ad-agent'
    })
  } else {
    next()
  }
}

const requireAuthAdmin = (to, from, next) => {
  if (!checkAuth() && !checkIsAdmin()) {
    const path = '/'
    next({
      path: path
    })
  } else {
    next()
  }
}

const requireAuthAdAgent = (to, from, next) => {
  if (!checkIsAddAgent()) {
    const path = '/'
    next({
      path: path
    })
  } else {
    next()
  }
}

export default {
  requireAuth,
  requireAuthAdmin,
  requireAuthAdAgent
}
